import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { ShopifyCurrency } from '../models/ShopifyCurrency.model';
import { shopifyState } from '../recoil/atoms';
import { isMobileState } from '../recoil/selectors';
import Link from '../root/components/Link';
import { assetPathFn, currencyToString } from '../util';
import styles from './HomePageSalePromo.module.scss';

export const HomePageSalePromo: React.FC = () => {
  const isMobile = useRecoilValue(isMobileState);

  const shopify = useRecoilValue(shopifyState);
  const currency: ShopifyCurrency = shopify?.currency ?? { active: 'USD', rate: 1 };
  const displayPice = currencyToString({ active: currency.active } as ShopifyCurrency, 75);

  return (
    <div className={styles.homePageSalePromo}>
      <div>
        <img alt={'anniversary sale'} src={assetPathFn(isMobile ? 'hero-anni-sale-mobile_x720.jpg' : 'hero-anni-sale-desktop_x1440.jpg')} />
      </div>
      <div>
        <h2>
          anniversary <span>sale</span>
        </h2>
        <div>
          Up to 50% off. {!isMobile && <br />}
          Save {displayPice} when you bundle {!isMobile && <br />}
          LiftWear Cami and Legging 2.0.
        </div>
        <Link
          text={'Shop now'}
          dataTrackLabel="Discount products"
          dataTrackLocation="Home page promo"
          buttonType={'transparent'}
          size={isMobile ? 'medium' : 'large'}
          href="/products"
        />
      </div>
    </div>
  );
};

export default HomePageSalePromo;
